import React from 'react'

const HomeSvg = () => {
  return (
  <svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  style={{marginBottom: '5px'}}
>
  <path
    d="M7.63105 17.3095V14.7539C7.63104 14.1039 8.16097 13.5757 8.81755 13.5713H11.2226C11.8823 13.5713 12.4171 14.1008 12.4171 14.7539V14.7539V17.3174C12.417 17.8693 12.8619 18.3204 13.4192 18.3333H15.0226C16.621 18.3333 17.9167 17.0506 17.9167 15.4682V15.4682V8.1982C17.9082 7.57569 17.6129 6.99113 17.115 6.61087L11.6315 2.23776C10.6708 1.47631 9.30521 1.47631 8.34456 2.23776L2.88506 6.6188C2.38526 6.99752 2.08953 7.58306 2.08337 8.20614V15.4682C2.08337 17.0506 3.3791 18.3333 4.97747 18.3333H6.58084C7.152 18.3333 7.61502 17.875 7.61502 17.3095V17.3095"
    stroke="black"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>

  )
}
const SmallCheckSvg= () => {
    return (
        <svg
            width={19}
            height={19}
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_68_3066)">
                <path
                    d="M3.04795 6.82414C2.9324 6.30364 2.95014 5.76239 3.09953 5.25058C3.24892 4.73876 3.52512 4.27295 3.90253 3.89634C4.27993 3.51972 4.74632 3.2445 5.25844 3.09618C5.77057 2.94786 6.31186 2.93125 6.83211 3.04789C7.11847 2.60005 7.51295 2.23149 7.9792 1.9762C8.44545 1.72091 8.96846 1.5871 9.50003 1.5871C10.0316 1.5871 10.5546 1.72091 11.0209 1.9762C11.4871 2.23149 11.8816 2.60005 12.1679 3.04789C12.689 2.93074 13.2312 2.94728 13.7442 3.09596C14.2571 3.24464 14.7241 3.52063 15.1017 3.89826C15.4794 4.2759 15.7554 4.74291 15.904 5.25585C16.0527 5.76879 16.0693 6.31101 15.9521 6.83206C16.4 7.11841 16.7685 7.51289 17.0238 7.97914C17.2791 8.44539 17.4129 8.96841 17.4129 9.49997C17.4129 10.0315 17.2791 10.5546 17.0238 11.0208C16.7685 11.4871 16.4 11.8815 15.9521 12.1679C16.0688 12.6881 16.0521 13.2294 15.9038 13.7416C15.7555 14.2537 15.4803 14.7201 15.1037 15.0975C14.7271 15.4749 14.2612 15.7511 13.7494 15.9005C13.2376 16.0499 12.6964 16.0676 12.1759 15.9521C11.8899 16.4016 11.4951 16.7718 11.028 17.0282C10.561 17.2846 10.0368 17.4191 9.50399 17.4191C8.97118 17.4191 8.44698 17.2846 7.97993 17.0282C7.51289 16.7718 7.11809 16.4016 6.83211 15.9521C6.31186 16.0687 5.77057 16.0521 5.25844 15.9038C4.74632 15.7555 4.27993 15.4802 3.90253 15.1036C3.52512 14.727 3.24892 14.2612 3.09953 13.7494C2.95014 13.2376 2.9324 12.6963 3.04795 12.1758C2.59666 11.8902 2.22494 11.4951 1.96736 11.0273C1.70978 10.5594 1.57471 10.034 1.57471 9.49997C1.57471 8.96591 1.70978 8.44052 1.96736 7.97268C2.22494 7.50484 2.59666 7.10974 3.04795 6.82414Z"
                    stroke="#FB991A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round" />
                <path
                    d="M7.125 9.50002L8.70833 11.0834L11.875 7.91669"
                    stroke="#FB991A"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_68_3066">
                    <rect width={19} height={19} fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

const GenuineSvg = () => {
  return (
<svg
  width={24}
  height={24}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M15.4772 12.89L16.9922 21.416C17.0092 21.5164 16.9951 21.6196 16.9519 21.7118C16.9086 21.8039 16.8382 21.8807 16.7502 21.9318C16.6621 21.9829 16.5605 22.0059 16.459 21.9977C16.3576 21.9895 16.261 21.9506 16.1822 21.886L12.6022 19.199C12.4294 19.0699 12.2195 19.0001 12.0037 19.0001C11.788 19.0001 11.5781 19.0699 11.4052 19.199L7.81924 21.885C7.74056 21.9494 7.6441 21.9884 7.54273 21.9966C7.44137 22.0048 7.33991 21.9818 7.2519 21.9309C7.16389 21.8799 7.09352 21.8033 7.05016 21.7113C7.0068 21.6194 6.99253 21.5163 7.00924 21.416L8.52324 12.89"
    stroke="#166534"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M12 14C15.3137 14 18 11.3137 18 8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8C6 11.3137 8.68629 14 12 14Z"
    stroke="#166534"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>


  )
}
const CertifiedSvg = () => {
  return (
<svg
  width={24}
  height={24}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M14.6999 6.29998C14.5166 6.48691 14.414 6.73823 14.414 6.99998C14.414 7.26173 14.5166 7.51305 14.6999 7.69998L16.2999 9.29998C16.4868 9.48321 16.7381 9.58584 16.9999 9.58584C17.2616 9.58584 17.5129 9.48321 17.6999 9.29998L21.4699 5.52998C21.9727 6.64117 22.1249 7.87921 21.9063 9.07913C21.6877 10.279 21.1086 11.3838 20.2461 12.2463C19.3837 13.1087 18.2789 13.6878 17.079 13.9064C15.8791 14.1251 14.641 13.9728 13.5299 13.47L6.61986 20.38C6.22203 20.7778 5.68246 21.0013 5.11986 21.0013C4.55725 21.0013 4.01768 20.7778 3.61986 20.38C3.22203 19.9822 2.99854 19.4426 2.99854 18.88C2.99854 18.3174 3.22203 17.7778 3.61986 17.38L10.5299 10.47C10.027 9.35879 9.87477 8.12075 10.0934 6.92083C10.312 5.72092 10.8911 4.61614 11.7536 3.7537C12.616 2.89127 13.7208 2.31215 14.9207 2.09352C16.1206 1.8749 17.3587 2.02714 18.4699 2.52998L14.7099 6.28998L14.6999 6.29998Z"
    stroke="#166534"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
  )
}
const LockSvg = () => {
  return (
<svg
  width={24}
  height={24}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
    stroke="#166534"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
    stroke="#166534"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>

  )
}
const EasySvg = () => {
  return (
<svg
  width={24}
  height={24}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3 12C3 13.78 3.52784 15.5201 4.51677 17.0001C5.50571 18.4802 6.91131 19.6337 8.55585 20.3149C10.2004 20.9961 12.01 21.1743 13.7558 20.8271C15.5016 20.4798 17.1053 19.6226 18.364 18.364C19.6226 17.1053 20.4798 15.5016 20.8271 13.7558C21.1743 12.01 20.9961 10.2004 20.3149 8.55585C19.6337 6.91131 18.4802 5.50571 17.0001 4.51677C15.5201 3.52784 13.78 3 12 3C9.48395 3.00947 7.06897 3.99122 5.26 5.74L3 8"
    stroke="#166534"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M3 3V8H8"
    stroke="#166534"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>


  )
}
const CartSvg = () => {
  return (
<svg
  width={24}
  height={24}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask
    id="mask0_179_572"
    style={{ maskType: "luminance" }}
    maskUnits="userSpaceOnUse"
    x={2}
    y={6}
    width={20}
    height={17}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 6.5401H21.5859V22.7217H2V6.5401Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask0_179_572)">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.71553 8.0401C6.27453 8.0401 4.80053 8.2181 4.37753 10.5021L3.60553 16.5021C3.35453 18.1851 3.54853 19.4031 4.18353 20.1401C4.81053 20.8681 5.93253 21.2221 7.61253 21.2221H15.9605C17.0085 21.2221 18.4395 21.0131 19.3035 20.0151C19.9895 19.2241 20.2255 18.0461 20.0055 16.5131L19.2265 10.4611C18.8945 8.9701 18.0185 8.0401 16.8945 8.0401H6.71553ZM15.9605 22.7221H7.61253C5.46953 22.7221 3.97653 22.1971 3.04753 21.1181C2.11453 20.0361 1.80253 18.4131 2.12053 16.2951L2.89653 10.2691C3.40653 7.5061 5.27153 6.5401 6.71553 6.5401H16.8945C18.3445 6.5401 20.1075 7.5031 20.7025 10.2041L21.4915 16.3111C21.7745 18.2821 21.4205 19.8631 20.4375 20.9971C19.4595 22.1251 17.9115 22.7221 15.9605 22.7221Z"
      fill="white"
    />
  </g>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M16.098 7.82031C15.684 7.82031 15.348 7.48431 15.348 7.07031C15.348 5.10131 13.746 3.50031 11.778 3.50031H11.763C10.822 3.50031 9.90496 3.87931 9.23996 4.54031C8.57196 5.20531 8.18896 6.12831 8.18896 7.07031C8.18896 7.48431 7.85296 7.82031 7.43896 7.82031C7.02496 7.82031 6.68896 7.48431 6.68896 7.07031C6.68896 5.73131 7.23296 4.42231 8.18096 3.47731C9.12596 2.53831 10.429 2.00031 11.76 2.00031H11.781C14.574 2.00031 16.848 4.27431 16.848 7.07031C16.848 7.48431 16.512 7.82031 16.098 7.82031Z"
    fill="white"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M14.7433 12.3242H14.6973C14.2833 12.3242 13.9473 11.9882 13.9473 11.5742C13.9473 11.1602 14.2833 10.8242 14.6973 10.8242C15.1113 10.8242 15.4703 11.1602 15.4703 11.5742C15.4703 11.9882 15.1573 12.3242 14.7433 12.3242Z"
    fill="white"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8.91219 12.3242H8.86719C8.45319 12.3242 8.11719 11.9882 8.11719 11.5742C8.11719 11.1602 8.45319 10.8242 8.86719 10.8242C9.28119 10.8242 9.64019 11.1602 9.64019 11.5742C9.64019 11.9882 9.32619 12.3242 8.91219 12.3242Z"
    fill="white"
  />
</svg>


  )
}
const SearchSvg = () => {
  return (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M18.0918 16.9083L15.0002 13.8416C16.2002 12.3453 16.7814 10.446 16.6242 8.53434C16.4669 6.62267 15.5832 4.84391 14.1548 3.56379C12.7263 2.28368 10.8617 1.59951 8.94427 1.65198C7.02686 1.70445 5.20243 2.48956 3.84612 3.84587C2.4898 5.20219 1.70469 7.02662 1.65222 8.94402C1.59976 10.8614 2.28392 12.7261 3.56404 14.1545C4.84415 15.583 6.62292 16.4667 8.53458 16.6239C10.4462 16.7812 12.3455 16.2 13.8418 14.9999L16.9085 18.0666C16.986 18.1447 17.0781 18.2067 17.1797 18.249C17.2812 18.2913 17.3902 18.3131 17.5002 18.3131C17.6102 18.3131 17.7191 18.2913 17.8206 18.249C17.9222 18.2067 18.0144 18.1447 18.0918 18.0666C18.242 17.9112 18.326 17.7035 18.326 17.4874C18.326 17.2713 18.242 17.0636 18.0918 16.9083ZM9.16683 14.9999C8.01311 14.9999 6.88529 14.6578 5.92601 14.0168C4.96672 13.3759 4.21905 12.4648 3.77753 11.3989C3.33602 10.333 3.2205 9.16012 3.44558 8.02856C3.67066 6.897 4.22624 5.8576 5.04204 5.0418C5.85785 4.22599 6.89725 3.67042 8.02881 3.44534C9.16036 3.22026 10.3333 3.33578 11.3992 3.77729C12.4651 4.2188 13.3761 4.96647 14.0171 5.92576C14.658 6.88505 15.0002 8.01286 15.0002 9.16659C15.0002 10.7137 14.3856 12.1974 13.2916 13.2914C12.1977 14.3853 10.7139 14.9999 9.16683 14.9999Z"
    fill="#555555"
  />
</svg>


  )
}
const BlackCheckSvg = () => {
  return (
<svg
  width={18}
  height={18}
  viewBox="0 0 18 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clipPath="url(#clip0_68_3413)">
    <path
      d="M9.0001 17.4001C13.6393 17.4001 17.4001 13.6393 17.4001 9.0001C17.4001 4.36091 13.6393 0.600098 9.0001 0.600098C4.36091 0.600098 0.600098 4.36091 0.600098 9.0001C0.600098 13.6393 4.36091 17.4001 9.0001 17.4001Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.25474 11.0957L4.96383 8.83895L4.2002 9.59119L7.25474 12.6001L13.8002 6.15239L13.0366 5.40015L7.25474 11.0957Z"
      fill="white"
      stroke="white"
      strokeWidth="0.233333"
    />
  </g>
  <defs>
    <clipPath id="clip0_68_3413">
      <rect width={18} height={18} fill="white" />
    </clipPath>
  </defs>
</svg>



  )
}
const FootballSvg = () => {
return (
<svg
  width={22}
  height={22}
  viewBox="0 0 22 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2.75 5.95833C2.75 3.55189 2.77577 2.75 5.95833 2.75C9.1409 2.75 9.16667 3.55189 9.16667 5.95833C9.16667 8.36478 9.17682 9.16667 5.95833 9.16667C2.73985 9.16667 2.75 8.36478 2.75 5.95833Z"
    stroke="white"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12.8333 5.95833C12.8333 3.55189 12.859 2.75 16.0416 2.75C19.2242 2.75 19.2499 3.55189 19.2499 5.95833C19.2499 8.36478 19.2601 9.16667 16.0416 9.16667C12.8231 9.16667 12.8333 8.36478 12.8333 5.95833Z"
    stroke="white"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2.75 16.0417C2.75 13.6352 2.77577 12.8333 5.95833 12.8333C9.1409 12.8333 9.16667 13.6352 9.16667 16.0417C9.16667 18.4481 9.17682 19.25 5.95833 19.25C2.73985 19.25 2.75 18.4481 2.75 16.0417Z"
    stroke="white"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12.8333 16.0417C12.8333 13.6352 12.859 12.8333 16.0416 12.8333C19.2242 12.8333 19.2499 13.6352 19.2499 16.0417C19.2499 18.4481 19.2601 19.25 16.0416 19.25C12.8231 19.25 12.8333 18.4481 12.8333 16.0417Z"
    stroke="white"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>

  )
}
const CrossSvg = () => {
return (
<svg
  width={24}
  height={24}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M13.4099 12L17.7099 7.71C17.8982 7.52169 18.004 7.2663 18.004 7C18.004 6.7337 17.8982 6.4783 17.7099 6.29C17.5216 6.10169 17.2662 5.99591 16.9999 5.99591C16.7336 5.99591 16.4782 6.10169 16.2899 6.29L11.9999 10.59L7.70994 6.29C7.52164 6.10169 7.26624 5.99591 6.99994 5.99591C6.73364 5.99591 6.47824 6.10169 6.28994 6.29C6.10164 6.4783 5.99585 6.7337 5.99585 7C5.99585 7.2663 6.10164 7.52169 6.28994 7.71L10.5899 12L6.28994 16.29C6.19621 16.383 6.12182 16.4936 6.07105 16.6154C6.02028 16.7373 5.99414 16.868 5.99414 17C5.99414 17.132 6.02028 17.2627 6.07105 17.3846C6.12182 17.5064 6.19621 17.617 6.28994 17.71C6.3829 17.8037 6.4935 17.8781 6.61536 17.9289C6.73722 17.9797 6.86793 18.0058 6.99994 18.0058C7.13195 18.0058 7.26266 17.9797 7.38452 17.9289C7.50638 17.8781 7.61698 17.8037 7.70994 17.71L11.9999 13.41L16.2899 17.71C16.3829 17.8037 16.4935 17.8781 16.6154 17.9289C16.7372 17.9797 16.8679 18.0058 16.9999 18.0058C17.132 18.0058 17.2627 17.9797 17.3845 17.9289C17.5064 17.8781 17.617 17.8037 17.7099 17.71C17.8037 17.617 17.8781 17.5064 17.9288 17.3846C17.9796 17.2627 18.0057 17.132 18.0057 17C18.0057 16.868 17.9796 16.7373 17.9288 16.6154C17.8781 16.4936 17.8037 16.383 17.7099 16.29L13.4099 12Z"
    fill="black"
  />
</svg>

  )
}
const RadioSvg = () => {
return (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect className='outer-circle' x="0.5" y="0.5" width={19} height={19} rx="9.5" stroke="#DDDDDD" />
  <rect className='inner-circle' x={4} y={4} width={12} height={12} rx={6} fill="#D9D9D9" />
</svg>

  )
}
const EmailgreySvg = () => {
  return (
<svg
  width={22}
  height={22}
  viewBox="0 0 22 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16.4108 8.11377L12.3378 11.4257C11.5683 12.0362 10.4856 12.0362 9.71603 11.4257L5.60864 8.11377"
    stroke="#555555"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M15.4997 19.25C18.2876 19.2577 20.1666 16.9671 20.1666 14.1518V7.85584C20.1666 5.04059 18.2876 2.75 15.4997 2.75H6.50013C3.71222 2.75 1.83325 5.04059 1.83325 7.85584V14.1518C1.83325 16.9671 3.71222 19.2577 6.50013 19.25H15.4997Z"
    stroke="#555555"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>

  );
};

const CancelSvg = () => {
  return (
<svg
  width={24}
  height={24}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M15.71 8.29008C15.617 8.19635 15.5064 8.12196 15.3845 8.07119C15.2627 8.02042 15.132 7.99428 15 7.99428C14.8679 7.99428 14.7372 8.02042 14.6154 8.07119C14.4935 8.12196 14.3829 8.19635 14.29 8.29008L12 10.5901L9.70996 8.29008C9.52165 8.10178 9.26626 7.99599 8.99996 7.99599C8.73366 7.99599 8.47826 8.10178 8.28996 8.29008C8.10165 8.47838 7.99587 8.73378 7.99587 9.00008C7.99587 9.26638 8.10165 9.52178 8.28996 9.71008L10.59 12.0001L8.28996 14.2901C8.19623 14.383 8.12183 14.4936 8.07107 14.6155C8.0203 14.7374 7.99416 14.8681 7.99416 15.0001C7.99416 15.1321 8.0203 15.2628 8.07107 15.3847C8.12183 15.5065 8.19623 15.6171 8.28996 15.7101C8.38292 15.8038 8.49352 15.8782 8.61538 15.929C8.73724 15.9797 8.86795 16.0059 8.99996 16.0059C9.13197 16.0059 9.26267 15.9797 9.38453 15.929C9.50639 15.8782 9.61699 15.8038 9.70996 15.7101L12 13.4101L14.29 15.7101C14.3829 15.8038 14.4935 15.8782 14.6154 15.929C14.7372 15.9797 14.8679 16.0059 15 16.0059C15.132 16.0059 15.2627 15.9797 15.3845 15.929C15.5064 15.8782 15.617 15.8038 15.71 15.7101C15.8037 15.6171 15.8781 15.5065 15.9288 15.3847C15.9796 15.2628 16.0058 15.1321 16.0058 15.0001C16.0058 14.8681 15.9796 14.7374 15.9288 14.6155C15.8781 14.4936 15.8037 14.383 15.71 14.2901L13.41 12.0001L15.71 9.71008C15.8037 9.61712 15.8781 9.50652 15.9288 9.38466C15.9796 9.2628 16.0058 9.13209 16.0058 9.00008C16.0058 8.86807 15.9796 8.73736 15.9288 8.6155C15.8781 8.49364 15.8037 8.38304 15.71 8.29008ZM19.07 4.93008C18.1475 3.97498 17.044 3.21316 15.824 2.68907C14.604 2.16498 13.2918 1.88911 11.964 1.87757C10.6362 1.86604 9.31938 2.11905 8.09042 2.62186C6.86145 3.12467 5.74493 3.8672 4.80601 4.80613C3.86708 5.74506 3.12455 6.86158 2.62174 8.09054C2.11893 9.3195 1.86591 10.6363 1.87745 11.9641C1.88899 13.2919 2.16485 14.6041 2.68894 15.8241C3.21303 17.0442 3.97486 18.1476 4.92996 19.0701C5.85243 20.0252 6.95587 20.787 8.17591 21.3111C9.39595 21.8352 10.7082 22.111 12.0359 22.1226C13.3637 22.1341 14.6805 21.8811 15.9095 21.3783C17.1385 20.8755 18.255 20.133 19.1939 19.194C20.1328 18.2551 20.8754 17.1386 21.3782 15.9096C21.881 14.6807 22.134 13.3639 22.1225 12.0361C22.1109 10.7083 21.8351 9.39607 21.311 8.17603C20.7869 6.95599 20.0251 5.85255 19.07 4.93008ZM17.66 17.6601C16.352 18.9695 14.6305 19.7849 12.7888 19.9674C10.947 20.1499 9.09896 19.6881 7.55948 18.6609C6.02 17.6336 4.88432 16.1043 4.34593 14.3336C3.80754 12.5628 3.89976 10.6602 4.60687 8.94986C5.31398 7.23951 6.59223 5.82723 8.22385 4.95364C9.85546 4.08006 11.7395 3.79921 13.555 4.15895C15.3704 4.5187 17.005 5.49677 18.1802 6.92654C19.3554 8.35631 19.9985 10.1493 20 12.0001C20.0035 13.0514 19.7985 14.0929 19.3969 15.0645C18.9952 16.036 18.4049 16.9182 17.66 17.6601Z"
    fill="black"
  />
</svg>

  );
};

const EyeOffSvg = () => {
  return (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16.154 3.09236C16.3922 2.85789 16.7779 2.8581 17.0163 3.09236C17.2546 3.32698 17.2546 3.70736 17.0163 3.94197L3.84637 16.9068C3.72721 17.0241 3.57057 17.0836 3.41473 17.0836C3.25818 17.0835 3.10218 17.024 2.98309 16.9068C2.74511 16.6723 2.74519 16.2929 2.98309 16.0592L7.31317 11.7955C6.94739 11.2705 6.74872 10.651 6.74872 10.0006C6.74876 8.23536 8.20655 6.79958 9.99969 6.79939C10.6554 6.79939 11.2941 6.99814 11.8249 7.35408L13.5202 5.68611C11.1303 4.15545 8.21577 4.28683 5.93915 6.06111C4.73665 6.99218 3.70389 8.35104 2.94305 10.0015C3.28134 10.7389 3.67471 11.419 4.11298 12.026C4.30793 12.2958 4.24442 12.6709 3.9704 12.8629C3.86294 12.9383 3.73933 12.9742 3.61688 12.9742C3.42605 12.9742 3.238 12.887 3.11884 12.7213C2.58397 11.9806 2.11127 11.1448 1.71552 10.2369C1.64974 10.086 1.64984 9.91318 1.71649 9.76228C2.56732 7.82316 3.76601 6.21709 5.18427 5.11873C7.93252 2.97861 11.5422 2.87308 14.3972 4.82283L16.154 3.09236ZM15.8522 6.93416C16.1206 6.73482 16.5024 6.78833 16.7057 7.0533C17.3091 7.84162 17.8387 8.75413 18.2829 9.76228C18.3495 9.91399 18.3495 10.087 18.2829 10.2379C16.5354 14.2236 13.4387 16.6031 9.99969 16.6031C9.21815 16.6031 8.44113 16.479 7.69208 16.233C7.37321 16.1271 7.2009 15.7872 7.30731 15.4732C7.41315 15.1582 7.75796 14.9908 8.0788 15.0933C8.70355 15.2983 9.34996 15.4019 9.99969 15.4019C12.8705 15.4019 15.493 13.3884 17.0563 10.0006C16.6739 9.17298 16.2295 8.42542 15.7321 7.77498C15.5297 7.51008 15.5824 7.13436 15.8522 6.93416ZM12.6999 9.87166C13.0315 9.92996 13.2521 10.2417 13.1921 10.5689C12.9553 11.8715 11.906 12.9051 10.5827 13.1422C10.5462 13.1479 10.5098 13.1509 10.4733 13.151C10.185 13.151 9.92705 12.9483 9.87372 12.6588C9.81387 12.3324 10.0343 12.0204 10.3659 11.9605C11.1908 11.8136 11.8436 11.1681 11.9919 10.356C12.0511 10.0313 12.3708 9.81261 12.6999 9.87166ZM9.99969 7.99959C8.87907 7.99982 7.96749 8.89656 7.96747 10.0006C7.96747 10.3261 8.05582 10.6362 8.20575 10.9176L10.9323 8.23396C10.6473 8.08716 10.3288 7.99959 9.99969 7.99959Z"
    fill="#555555"
  />
</svg>


  );
};

const EyeSmallSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 10C1 10 5 4 10 4C15 4 19 10 19 10C19 10 15 16 10 16C5 16 1 10 1 10Z"
        stroke="#555555"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="10"
        cy="10"
        r="3"
        stroke="#555555"
        strokeWidth="2"
      />
    </svg>
  );
};
const EditSvg = () => {
  return (
<svg
  width={15}
  height={15}
  viewBox="0 0 15 15"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M8.59204 12.7769H13.1249"
    stroke="black"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7.9875 2.37175C8.47228 1.79237 9.34374 1.70741 9.93514 2.18233C9.96784 2.2081 11.0184 3.02424 11.0184 3.02424C11.6681 3.41699 11.87 4.25194 11.4684 4.88912C11.447 4.92324 5.50747 12.3528 5.50747 12.3528C5.30986 12.5993 5.0099 12.7449 4.68932 12.7483L2.41471 12.7769L1.90221 10.6077C1.83041 10.3027 1.90221 9.98236 2.09981 9.73584L7.9875 2.37175Z"
    stroke="black"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M6.88794 3.75049L10.2956 6.36744"
    stroke="black"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>

  );
};
const MyorderSvg = () => {
  return (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2.5 5.41667C2.5 3.22899 2.52342 2.5 5.41667 2.5C8.30991 2.5 8.33333 3.22899 8.33333 5.41667C8.33333 7.60434 8.34256 8.33333 5.41667 8.33333C2.49077 8.33333 2.5 7.60434 2.5 5.41667Z"
    stroke="#555555"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11.6667 5.41667C11.6667 3.22899 11.6902 2.5 14.5834 2.5C17.4767 2.5 17.5001 3.22899 17.5001 5.41667C17.5001 7.60434 17.5093 8.33333 14.5834 8.33333C11.6575 8.33333 11.6667 7.60434 11.6667 5.41667Z"
    stroke="#555555"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2.5 14.5832C2.5 12.3955 2.52342 11.6665 5.41667 11.6665C8.30991 11.6665 8.33333 12.3955 8.33333 14.5832C8.33333 16.7708 8.34256 17.4998 5.41667 17.4998C2.49077 17.4998 2.5 16.7708 2.5 14.5832Z"
    stroke="#555555"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11.6667 14.5832C11.6667 12.3955 11.6902 11.6665 14.5834 11.6665C17.4767 11.6665 17.5001 12.3955 17.5001 14.5832C17.5001 16.7708 17.5093 17.4998 14.5834 17.4998C11.6575 17.4998 11.6667 16.7708 11.6667 14.5832Z"
    stroke="#555555"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>

  );
};
const WishlistSvg = () => {
  return (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2.39314 9.66527C1.49897 6.8736 2.54397 3.68277 5.47481 2.7386C7.01647 2.2411 8.71814 2.53443 9.99981 3.4986C11.2123 2.5611 12.9765 2.24443 14.5165 2.7386C17.4473 3.68277 18.499 6.8736 17.6056 9.66527C16.214 14.0903 9.99981 17.4986 9.99981 17.4986C9.99981 17.4986 3.83147 14.1419 2.39314 9.66527Z"
    stroke="#555555"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M13.3333 5.5835C14.2249 5.87183 14.8549 6.66766 14.9308 7.60183"
    stroke="#555555"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>


  );
};

export const RateUsSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1.6665L12.575 6.88317L18.3334 7.72484L14.1667 11.7748L15.15 17.4998L10 14.8082L4.84998 17.4998L5.83331 11.7748L1.66665 7.72484L7.42498 6.88317L10 1.6665Z"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="15" cy="5" r="1" fill="#555555" opacity="0.7" />
      <circle cx="4" cy="8" r="0.8" fill="#555555" opacity="0.5" />
      <circle cx="17" cy="12" r="0.6" fill="#555555" opacity="0.6" />
    </svg>
  );
};

const LogoutSvg = () => {
  return (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M13.177 10.0182H3.14282"
    stroke="#555555"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M10.7373 7.58838L13.1773 10.0184L10.7373 12.4484"
    stroke="#555555"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M7.08691 6.15756V5.38006C7.08691 3.68423 8.46108 2.31006 10.1577 2.31006H14.2277C15.9194 2.31006 17.2902 3.68089 17.2902 5.37256V14.6559C17.2902 16.3517 15.9152 17.7267 14.2194 17.7267H10.1486C8.45775 17.7267 7.08691 16.3551 7.08691 14.6642V13.8792"
    stroke="#555555"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>

  );
};
const ProfileSvg = () => {
  return (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.98712 12.7886C6.7641 12.7886 4.01172 13.2759 4.01172 15.2275C4.01172 17.1791 6.74664 17.6838 9.98712 17.6838C13.2101 17.6838 15.9617 17.1957 15.9617 15.2449C15.9617 13.2941 13.2276 12.7886 9.98712 12.7886Z"
    stroke="white"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.98716 10.0047C12.1022 10.0047 13.8165 8.28966 13.8165 6.17458C13.8165 4.0595 12.1022 2.34521 9.98716 2.34521C7.87208 2.34521 6.157 4.0595 6.157 6.17458C6.14986 8.28252 7.85304 9.9976 9.96018 10.0047H9.98716Z"
    stroke="white"
    strokeWidth="1.42857"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>


  );
};
const StatusSvg = () => {
  return (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2.5 5.41667C2.5 3.22899 2.52342 2.5 5.41667 2.5C8.30991 2.5 8.33333 3.22899 8.33333 5.41667C8.33333 7.60434 8.34256 8.33333 5.41667 8.33333C2.49077 8.33333 2.5 7.60434 2.5 5.41667Z"
    stroke="black"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11.6665 5.41667C11.6665 3.22899 11.6899 2.5 14.5832 2.5C17.4764 2.5 17.4998 3.22899 17.4998 5.41667C17.4998 7.60434 17.5091 8.33333 14.5832 8.33333C11.6573 8.33333 11.6665 7.60434 11.6665 5.41667Z"
    stroke="black"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M2.5 14.5832C2.5 12.3955 2.52342 11.6665 5.41667 11.6665C8.30991 11.6665 8.33333 12.3955 8.33333 14.5832C8.33333 16.7708 8.34256 17.4998 5.41667 17.4998C2.49077 17.4998 2.5 16.7708 2.5 14.5832Z"
    stroke="black"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11.6665 14.5832C11.6665 12.3955 11.6899 11.6665 14.5832 11.6665C17.4764 11.6665 17.4998 12.3955 17.4998 14.5832C17.4998 16.7708 17.5091 17.4998 14.5832 17.4998C11.6573 17.4998 11.6665 16.7708 11.6665 14.5832Z"
    stroke="black"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
  );
};
const DateSvg = () => {
  return (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M17.222 8.25342H2.36865C2.02365 8.25342 1.74365 7.97342 1.74365 7.62842C1.74365 7.28342 2.02365 7.00342 2.36865 7.00342H17.222C17.567 7.00342 17.847 7.28342 17.847 7.62842C17.847 7.97342 17.567 8.25342 17.222 8.25342Z"
    fill="black"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13.5009 11.5078C13.1559 11.5078 12.8726 11.2278 12.8726 10.8828C12.8726 10.5378 13.1484 10.2578 13.4934 10.2578H13.5009C13.8459 10.2578 14.1259 10.5378 14.1259 10.8828C14.1259 11.2278 13.8459 11.5078 13.5009 11.5078Z"
    fill="black"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.80314 11.5078C9.45814 11.5078 9.1748 11.2278 9.1748 10.8828C9.1748 10.5378 9.45064 10.2578 9.79564 10.2578H9.80314C10.1481 10.2578 10.4281 10.5378 10.4281 10.8828C10.4281 11.2278 10.1481 11.5078 9.80314 11.5078Z"
    fill="black"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6.09743 11.5078C5.75243 11.5078 5.46826 11.2278 5.46826 10.8828C5.46826 10.5378 5.74493 10.2578 6.08993 10.2578H6.09743C6.44243 10.2578 6.72243 10.5378 6.72243 10.8828C6.72243 11.2278 6.44243 11.5078 6.09743 11.5078Z"
    fill="black"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13.5009 14.7471C13.1559 14.7471 12.8726 14.4671 12.8726 14.1221C12.8726 13.7771 13.1484 13.4971 13.4934 13.4971H13.5009C13.8459 13.4971 14.1259 13.7771 14.1259 14.1221C14.1259 14.4671 13.8459 14.7471 13.5009 14.7471Z"
    fill="black"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.80314 14.7471C9.45814 14.7471 9.1748 14.4671 9.1748 14.1221C9.1748 13.7771 9.45064 13.4971 9.79564 13.4971H9.80314C10.1481 13.4971 10.4281 13.7771 10.4281 14.1221C10.4281 14.4671 10.1481 14.7471 9.80314 14.7471Z"
    fill="black"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6.09743 14.7471C5.75243 14.7471 5.46826 14.4671 5.46826 14.1221C5.46826 13.7771 5.74493 13.4971 6.08993 13.4971H6.09743C6.44243 13.4971 6.72243 13.7771 6.72243 14.1221C6.72243 14.4671 6.44243 14.7471 6.09743 14.7471Z"
    fill="black"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13.1611 4.826C12.8161 4.826 12.5361 4.546 12.5361 4.201V1.4585C12.5361 1.1135 12.8161 0.833496 13.1611 0.833496C13.5061 0.833496 13.7861 1.1135 13.7861 1.4585V4.201C13.7861 4.546 13.5061 4.826 13.1611 4.826Z"
    fill="black"
  />
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M6.4292 4.826C6.0842 4.826 5.8042 4.546 5.8042 4.201V1.4585C5.8042 1.1135 6.0842 0.833496 6.4292 0.833496C6.7742 0.833496 7.0542 1.1135 7.0542 1.4585V4.201C7.0542 4.546 6.7742 4.826 6.4292 4.826Z"
    fill="black"
  />
  <mask
    id="mask0_87_5150"
    style={{ maskType: "luminance" }}
    maskUnits="userSpaceOnUse"
    x={1}
    y={2}
    width={17}
    height={17}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.6665 2.14941H17.9165V18.7502H1.6665V2.14941Z"
      fill="white"
    />
  </mask>
  <g mask="url(#mask0_87_5150)">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.26734 3.39941C4.1065 3.39941 2.9165 4.55191 2.9165 6.64441V14.1852C2.9165 16.3236 4.1065 17.5002 6.26734 17.5002H13.3157C15.4765 17.5002 16.6665 16.3452 16.6665 14.2486V6.64441C16.6698 5.61525 16.3932 4.81525 15.844 4.26525C15.279 3.69858 14.4082 3.39941 13.3232 3.39941H6.26734ZM13.3157 18.7502H6.26734C3.42984 18.7502 1.6665 17.0011 1.6665 14.1852V6.64441C1.6665 3.87108 3.42984 2.14941 6.26734 2.14941H13.3232C14.7473 2.14941 15.9248 2.57608 16.729 3.38191C17.5098 4.16608 17.9207 5.29358 17.9165 6.64608V14.2486C17.9165 17.0252 16.1532 18.7502 13.3157 18.7502Z"
      fill="black"
    />
  </g>
</svg>

  );
};
const ThreedotSvg = () => {
  return (
<svg
  width={20}
  height={20}
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M10.8337 10.0007C10.8337 9.54041 10.4606 9.16732 10.0003 9.16732C9.54009 9.16732 9.16699 9.54041 9.16699 10.0007C9.16699 10.4609 9.54009 10.834 10.0003 10.834C10.4606 10.834 10.8337 10.4609 10.8337 10.0007Z"
    stroke="black"
    strokeOpacity="0.6"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M10.8337 4.16667C10.8337 3.70643 10.4606 3.33333 10.0003 3.33333C9.54009 3.33333 9.16699 3.70643 9.16699 4.16667C9.16699 4.6269 9.54009 5 10.0003 5C10.4606 5 10.8337 4.6269 10.8337 4.16667Z"
    stroke="black"
    strokeOpacity="0.6"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M10.8337 15.8337C10.8337 15.3734 10.4606 15.0003 10.0003 15.0003C9.54009 15.0003 9.16699 15.3734 9.16699 15.8337C9.16699 16.2939 9.54009 16.667 10.0003 16.667C10.4606 16.667 10.8337 16.2939 10.8337 15.8337Z"
    stroke="black"
    strokeOpacity="0.6"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>


  );
};

const EmptyStar = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="#e0e0e0"
      xmlns="http://www.w3.org/2000/svg"
       style={{
        position: 'absolute',
          top: 0,
          left: 0,
        }}
    >
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
    </svg>
  )
}
const HalfStar = ({ star }) => {
  return (
    <div style={{ position: 'relative', width: '20px', height: '20px' }}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="#e0e0e0"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'absolute', top: 0, left: 0 }}
      >
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
      </svg>
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="#FB991A"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          clipPath: `inset(0 ${100 - star.percentage}% 0 0)`
        }}
      >
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
      </svg>
    </div>
  )
}
const FullStar = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="#FB991A"
      xmlns="http://www.w3.org/2000/svg"
       style={{ position: 'absolute', top: 0, left: 0 }}
    >
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
    </svg>
  )
}

export {EmptyStar, HalfStar, FullStar, HomeSvg , SmallCheckSvg ,GenuineSvg ,CertifiedSvg ,LockSvg , EasySvg ,CartSvg ,SearchSvg ,BlackCheckSvg ,FootballSvg ,CrossSvg ,RadioSvg ,EmailgreySvg ,CancelSvg ,EyeOffSvg ,EyeSmallSvg ,EditSvg ,MyorderSvg ,WishlistSvg ,LogoutSvg ,ProfileSvg ,StatusSvg ,DateSvg ,ThreedotSvg}
